import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'

import 'es6-promise/auto'
import es6Promise from 'es6-promise'

import './plugins/element.js'
import 'element-ui/packages/theme-chalk/src/index.scss'

import './App.scss'

es6Promise.polyfill()

Vue.config.productionTip = false

axios.get(`${process.env.BASE_URL}config.json?t=${new Date().getTime()}`).then(response => {
  if (response.status === 200) {
    Vue.prototype.$APP_CONFIG = response.data
    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app')
  }
})
